<template>
  <div class="three-animation-container" ref="threeContainer">
  </div>
</template>

<script src="./three-animation.js"></script>
<style src="./three-animation.scss" lang="scss"></style>